/**
 * Upload Banking Arche Page
 *
 * Route wrapper: ArcheLayout + Routes for the upload-banking arche.
 */

import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { UploadBankingPage } from './UploadBankingPage';

export function UploadBankingArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/*" element={<UploadBankingPage />} />
      </Routes>
    </ArcheLayout>
  );
}
